export enum ReleaseChannels {
	PRODUCTION = "PRODUCTION",
	STAGING = "STAGING",
	DEVELOP = "DEVELOP"
}
